"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listQueueQuerySchema = exports.QUEUE_REQUEST_EXAMPLES = exports.priorityQueueRequestSchema = exports.skipPatientRequestSchema = exports.recallPatientRequestSchema = exports.moveQueueRequestSchema = exports.generateTokenRequestSchema = exports.generateQueueRequestSchema = void 0;
/**
 * Request contracts for the 6 Queue endpoints. Field shapes mirror
 * `QueueApplicationService`'s own method input shapes (backend,
 * frozen, Stage 5B.4).
 */
const zod_1 = require("zod");
const appointment_common_request_1 = require("./appointment-common.request");
exports.generateQueueRequestSchema = zod_1.z.object({
    visitId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid(),
    doctorId: zod_1.z.string().uuid().optional(),
    appointmentId: zod_1.z.string().uuid().optional(),
    priorityTier: zod_1.z.number().int(),
});
exports.generateTokenRequestSchema = zod_1.z.object({
    visitId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid().optional(),
});
exports.moveQueueRequestSchema = zod_1.z.object({
    queueEntryId: zod_1.z.string().uuid(),
    toDoctorId: zod_1.z.string().uuid(),
    notes: zod_1.z.string().optional(),
    changedBy: zod_1.z.string().uuid().optional(),
});
const queueActionRequestSchema = zod_1.z.object({
    queueEntryId: zod_1.z.string().uuid(),
    notes: zod_1.z.string().optional(),
    changedBy: zod_1.z.string().uuid().optional(),
});
exports.recallPatientRequestSchema = queueActionRequestSchema;
exports.skipPatientRequestSchema = queueActionRequestSchema;
exports.priorityQueueRequestSchema = appointment_common_request_1.priorityTierInputSchema;
const UUID = '30000000-0000-0000-0000-000000000001';
exports.QUEUE_REQUEST_EXAMPLES = {
    generateQueue: {
        visitId: '20000000-0000-0000-0000-000000000001',
        branchId: '33333333-3333-3333-3333-333333333333',
        departmentId: '44444444-4444-4444-4444-444444444444',
        priorityTier: 0,
    },
    generateToken: {
        visitId: '20000000-0000-0000-0000-000000000001',
        branchId: '33333333-3333-3333-3333-333333333333',
    },
    moveQueue: {
        queueEntryId: UUID,
        toDoctorId: '22222222-2222-2222-2222-222222222222',
    },
    recallPatient: { queueEntryId: UUID },
    skipPatient: { queueEntryId: UUID },
    priorityQueue: { isEmergency: true },
};
/**
 * P0-3 — the queue read's query. Same capping discipline as the encounter
 * list: bounded by default, because a waiting-room board polls.
 */
exports.listQueueQuerySchema = zod_1.z.object({
    departmentId: zod_1.z.string().uuid().optional(),
    doctorId: zod_1.z.string().uuid().optional(),
    status: zod_1.z.enum(['WAITING', 'CALLED', 'IN_CONSULTATION', 'SKIPPED', 'COMPLETED', 'CANCELLED']).optional(),
    page: zod_1.z.coerce.number().int().positive().default(1),
    limit: zod_1.z.coerce.number().int().positive().max(100).default(50),
});
//# sourceMappingURL=queue.request.js.map